import React from 'react'
import { Modal } from 'react-bootstrap'
import { WifiSettingsContent } from './WifiSettingsContent'

const WifiSettingsModal = ({ show, onHide }) => {
    return (
        <Modal show={show} onHide={onHide} size='xl' centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Network Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <WifiSettingsContent />
            </Modal.Body>
        </Modal>
    )
}

export { WifiSettingsModal }
